import React, { useState } from 'react';

const ImagesSection = ({ formData, setFormData, API_BASE_URL }) => {
  const [imageUrl, setImageUrl] = useState('');
  const [uploading, setUploading] = useState(false);
  const images = formData.images || [];

  const addImageUrl = () => {
    if (imageUrl.trim()) {
      setFormData(prev => ({
        ...prev,
        images: [...(prev.images || []), imageUrl.trim()]
      }));
      setImageUrl('');
    }
  };

  const removeImage = (idx) => {
    const updated = images.filter((_, i) => i !== idx);
    setFormData(prev => ({ ...prev, images: updated }));
  };

  const moveImage = (idx, direction) => {
    const target = idx + direction;
    if (target < 0 || target >= images.length) return;
    const updated = [...images];
    [updated[idx], updated[target]] = [updated[target], updated[idx]];
    setFormData(prev => ({ ...prev, images: updated }));
  };

  const setPrimary = (idx) => {
    if (idx === 0) return;
    const updated = [...images];
    [updated[0], updated[idx]] = [updated[idx], updated[0]];
    setFormData(prev => ({ ...prev, images: updated }));
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('image', file);
      const resp = await fetch(`${API_BASE_URL}/api/upload`, { method: 'POST', body: fd });
      if (!resp.ok) throw new Error(`Upload failed: ${await resp.text()}`);
      const result = await resp.json();
      const fullUrl = result.url.startsWith('http') ? result.url : `${API_BASE_URL}${result.url}`;
      setFormData(prev => ({
        ...prev,
        images: [...(prev.images || []), fullUrl]
      }));
    } catch (err) {
      console.error('Upload error:', err);
      alert(`Failed to upload image: ${err.message}`);
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div className="form-section">
      <h3>Images</h3>
      <div className="images-section">
        {images.length === 0 && (
          <p className="text-muted">No images added yet.</p>
        )}
        <div className="image-list">
          {images.map((img, idx) => (
            <div key={idx} className="image-item">
              <img
                src={img}
                alt={`Product ${idx + 1}`}
                className="image-preview"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <span className="image-path">{img.split('/').pop() || img}</span>
              <div className="image-actions">
                {idx > 0 && (
                  <button type="button" className="btn btn-sm btn-outline" onClick={() => moveImage(idx, -1)} title="Move Up">
                    ↑
                  </button>
                )}
                {idx < images.length - 1 && (
                  <button type="button" className="btn btn-sm btn-outline" onClick={() => moveImage(idx, 1)} title="Move Down">
                    ↓
                  </button>
                )}
                {idx > 0 && (
                  <button type="button" className="btn btn-sm btn-outline" onClick={() => setPrimary(idx)} title="Set as Primary">
                    ★
                  </button>
                )}
                {idx === 0 && <span className="primary-badge" title="Primary Image">★</span>}
                <button type="button" className="btn btn-sm btn-danger" onClick={() => removeImage(idx)} title="Remove">
                  ×
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="image-add-row">
          <input
            type="text"
            placeholder="Paste image URL..."
            className="form-control"
            value={imageUrl}
            onChange={e => setImageUrl(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') addImageUrl(); }}
          />
          <button type="button" className="btn btn-sm btn-primary" onClick={addImageUrl}>
            Add URL
          </button>
        </div>
        <div className="image-upload-row">
          <input
            type="file"
            id="image-file-input"
            accept="image/jpeg,image/png,image/gif,image/webp,image/svg+xml"
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />
          <button
            type="button"
            className="btn btn-sm btn-outline"
            disabled={uploading}
            onClick={() => document.getElementById('image-file-input').click()}
          >
            {uploading ? 'Uploading...' : 'Upload from Computer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImagesSection;
